import { useCallback, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { post } from "src/utils/networkUtils";
import InboxUserSearch from "src/components/inbox-table/InboxUserSearch";

const EMPTY_USERS = [];

export default function GrantHammersDialog(props) {
  const { open, campaign, onClose, onGranted } = props;
  const [userIds, setUserIds] = useState([]);
  const [hammers, setHammers] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setUserIds([]);
      setHammers(campaign?.hammersPerRedemption ?? "");
      setNote("");
    }
  }, [open, campaign]);

  // InboxUserSearch calls this from an effect, so it must stay stable
  const handleUserSelect = useCallback((ids) => {
    setUserIds(ids);
  }, []);

  const handleGrant = () => {
    setSaving(true);
    post(`/admin/hammer-smash/${campaign.campaignId}/grant`, {
      userId: userIds[0],
      hammers: +hammers,
      note,
    })
      .then(function () {
        onGranted();
      })
      .catch(function (error) {
        console.error("Error granting hammers:", error);
      })
      .finally(function () {
        setSaving(false);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Grant postal entry</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Postal entries don't count toward the purchase redemption limit.
        </DialogContentText>
        <Stack spacing={2}>
          <InboxUserSearch users={EMPTY_USERS} onUserSelect={handleUserSelect} />
          {userIds.length > 1 && (
            <DialogContentText color="error">Select only one user.</DialogContentText>
          )}
          <TextField
            label="Hammers"
            type="number"
            value={hammers}
            onChange={(e) => setHammers(e.target.value)}
            fullWidth
          />
          <TextField
            label="Note (e.g. postal reference)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleGrant}
          disabled={saving || userIds.length !== 1 || !(+hammers > 0)}
        >
          Grant
        </Button>
      </DialogActions>
    </Dialog>
  );
}
